import React from "react";
import PropTypes from "prop-types";
import { Dropdown, DropdownButton, InputGroup, Form } from "react-bootstrap";

export const ShopGridFilters = React.memo(function ShopGridFilters({
  searchFilter,
  onSearchFilterChange,
  divisionFilter,
  onDivisionFilterChange,
  divisionNames,
}) {
  return (
    <div className="float-right">
      <InputGroup size="lg" className="my-5">
        <InputGroup.Prepend>
          <InputGroup.Text id="search-form">Cerca</InputGroup.Text>
        </InputGroup.Prepend>
        <Form.Control
          key="form_search_key"
          aria-label="Cerca"
          aria-describedby="search-form"
          type="text"
          style={{ maxWidth: 300 }}
          value={searchFilter}
          onChange={(e) => onSearchFilterChange(e.target.value)}
        />
        <DropdownButton
          key="button_dropdown"
          as={InputGroup.Append}
          variant="secondary"
          title={divisionNames[divisionFilter]}
        >
          {Object.entries(divisionNames).map(([value, label]) => (
            <Dropdown.Item key={value} onClick={() => onDivisionFilterChange(Number(value))}>
              {label}
            </Dropdown.Item>
          ))}
        </DropdownButton>
      </InputGroup>
    </div>
  );
});

ShopGridFilters.propTypes = {
  searchFilter: PropTypes.string.isRequired,
  onSearchFilterChange: PropTypes.func.isRequired,
  divisionFilter: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  onDivisionFilterChange: PropTypes.func.isRequired,
  divisionNames: PropTypes.object.isRequired,
};
